import * as React from 'react';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import { TransitionGroup } from 'react-transition-group';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Button": Button, "@mui/material/Collapse": Collapse, "@mui/material/IconButton": IconButton, "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemText": ListItemText, "@mui/icons-material/Delete": DeleteIcon, "react-transition-group": { TransitionGroup } } } });
export default ClientProvider;
